// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Material
import { CircularProgress } from "@material-ui/core";
// Vendor
import {
  showNotify,
  updateLimitsIntegrations
} from "vendor/application/disptach";
// Infrastructure
import { IntegrationsAPI } from "api/application/Integrations";
// Application
import { getDialog360Body } from "vendor/application";
import { ElementsHandleAPI } from "vendor/application/handleMethods";
// Translations
import { withTranslation } from "react-i18next";
// Components
import { Button } from "@components/Input";
import Dialog360FormFields from "./Dialog360FormFields";
// SVG
import { channelsSvg } from "assets";
import { arrowRightSvg } from "@assets";

class Create extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialog360: getDialog360Body(),
      integration: false
    };
  }

  updateElement = (e, type, i) => {
    const { dialog360 } = this.state;
    const obj = new ElementsHandleAPI(dialog360.info, e.target.value, type, i);
    obj.updateObj();
    this.setState({ dialog360: dialog360 });
  };

  return = () => {
    const { history } = this.props;
    const { actualProject } = this.props.data;
    history.push(`/${actualProject.id}/integrations/dialog360`);
  };

  postIntegration = async (e) => {
    e.preventDefault();
    const { access, actualProject } = this.props.data;
    const { history } = this.props;
    const { dialog360 } = this.state;

    try {
      const obj = new IntegrationsAPI(
        actualProject.id,
        access,
        this.props,
        dialog360
      );
      let integration = await obj.post_integration();

      this.props.dispatch(
        showNotify({
          message: "integrations",
          type: "create",
          severity: "success"
        })
      );

      this.props.data.limitsIntegrations.dialog360.existIntegration = true;
      this.props.dispatch(
        updateLimitsIntegrations(this.props.data.limitsIntegrations)
      );

      history.push(
        `/${actualProject.id}/integrations/dialog360/edit/${integration.id}`
      );
    } catch (err) {
      this.props.dispatch(showNotify({ message: err, severity: "error" }));
    }
  };

  render() {
    const { dialog360 } = this.state;
    const { t } = this.props;
    const { isSending } = this.props.data;
    return (
      dialog360 && (
        <div className={"cen_integrations"}>
          <div className={"header"}>
            <div className={"header_content"}>
              <div onClick={() => this.return()} className={"header_action"}>
                {arrowRightSvg()}
              </div>
              <div className={"header_image"}>{channelsSvg("dialog360")}</div>
              <div className={"header_title"}>
                <span className={"title"}>
                  {t("integrations:channels.dialog360.title")}
                </span>
                <span className={"description"}>
                  {t("integrations:categories.customer")}
                </span>
              </div>
            </div>
            <div className={"header_actions"}>
              {isSending ? (
                <Button
                  type={"primary"}
                  disabled
                  text={<CircularProgress size={21} />}
                />
              ) : (
                <Button
                  type={"primary"}
                  text={t("integrations:create.action_button")}
                  onClick={(e) => this.postIntegration(e)}
                />
              )}
            </div>
          </div>
          <div className={"integration"}>
            <Dialog360FormFields
              t={t}
              dialog360={dialog360}
              updateElement={this.updateElement}
            />
          </div>
        </div>
      )
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state
  };
};

const create = connect(mapStateToProps)(Create);

export default withTranslation(["commons", "common"])(withRouter(create));
